import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import Modal from '../../components/modals';
import '../../App.css';

const AnyReactComponent = ({ text }) => <Modal text={text} />;

const GoogleMapComponent = () => {
  const [center, setCenter] = useState({
    lat: 24.899536,
    lng: 91.845856,
  });
  const [zoom, setZoom] = useState(11);

  const handleZoomChanged = () => {
    // const { bounds, center } = e;
    setCenter({
      lat: 24.899536,
      lng: 91.845856,
    });
    setZoom(12);
    // const { lat: centerLat, lng: centerLng } = center;
    // setCenterCordinate([centerLat, centerLng]);
    // const { ne, sw } = bounds;
    // const { lat: latR, lng: lngR } = ne;
    // const { lat: latL, lng: lngL } = sw;
    // if (!clicked) {
    //   // if the search as I move feature isn't on , then set map movement to true
    //   setMapMoved(true);
  };
  return (
    <div style={{ height: '50vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyDFBLiV8Took-03KgKIkP8eYwM66jqTfqI' }}
        defaultCenter={center}
        defaultZoom={zoom}
        onChange={(e) => handleZoomChanged(e)}
      >
        <AnyReactComponent
          lat={24.899536}
          lng={91.845856}
          text="Shamimabad, sylhet, bangladesh"
        />
        <AnyReactComponent
          lat={25.1634}
          lng={92.0175}
          text="Japlong, sylhet, bangladesh"
        />
      </GoogleMapReact>
    </div>
  );
};

export default GoogleMapComponent;
